import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";
import type { GetOrganisationUsersResponse } from "./getOrganisationUsers";

const endpoint = spellbook("/me/organisations/users/{id}").DELETE();

export async function deactivateUser(id: string): Promise<GetOrganisationUsersResponse | null> {
    const call = createCall(endpoint, (request) => fetch(withAccountOrNetworkAuthHeaders(request)));

    try {
        return await call({ params: { id } });
    } catch {
        // Spellbook handles the toast and auth redirect; keep this direct caller quiet.
        return null;
    }
}
